export default (vgorode: string, phone: string) => {
  return `
  <p>Наборы роллов и суши сеты - это идеальный выбор для тех, кто хочет насладиться разнообразием вкусов и текстур в одном заказе.
      Каждая позиция в меню представляет собой композицию из различных видов суши и роллов, которые гармонично сочетаются друг с другом,
      образуя настоящее кулинарное произведение искусства. Все наборы тщательно подобраны, чтобы удовлетворить самые изысканные вкусы и предпочтения.</p>

<p>Не упустите возможность попробовать восхитительные суши сеты прямо у себя дома или в офисе в ${vgorode}.
    Оформите заказ прямо сейчас и насладитесь изысканным вкусом и ароматом японской кухни.
    Мы гарантируем незабываемый гастрономический опыт и полное удовлетворение каждого гостя вашего мероприятия.</p>

<h2>Суши и роллы для компании</h2>

<p>Суши сеты и наборы роллов - это отличное решение для офисных обедов, корпоративных мероприятий или дружеских встреч.
    Вы можете выбрать наборы с разными видами рыбы, овощами, морепродуктами или комбинации из них.
    Это позволяет угодить всем гостям и организовать вкусный ужин, который понравится каждому.
    Заказывая набор суши у нас, вы получаете не только вкусное и питательное блюдо, но и возможность сэкономить время на готовке для большой компании.</p>

<p>Кроме того, наши наборы роллов и суши имеют различные размеры, чтобы соответствовать размеру компании.
    Вы можете выбрать наборы на 10, 20 или даже 30 человек, чтобы угостить всех гостей.
    Наша команда готова помочь с выбором и оформлением заказа, чтобы вы получили идеальное сочетание блюд для мероприятия.</p>

<h2>Заказать набор суши</h2>

<p>Заказать суши сет в ${vgorode} легко и удобно. Ознакомьтесь с нашим разнообразным ассортиментом и оформите заказ на сайте,
    в приложении или по номеру телефона ${phone}. У нас вы найдете различные варианты, начиная от классических наборов
    с утонченными роллами и изысканными суши из свежей рыбы, до авторских сетов, включающих интересные сочетания ингредиентов и необычные соусы.
    Все блюда из меню созданы с использованием только высококачественных и свежих продуктов. Мы тщательно отбираем рыбу, овощи и рис для суши,
    чтобы обеспечить наилучший вкус и непревзойденное качество. Команда профессиональных сушистов уделяет внимание каждой детали приготовления,
    чтобы достичь идеального баланса вкуса, текстуры и аромата.</p>

<p>Заказывая суши сет у нас, вы можете быть уверены в своевременной доставке и безопасности каждого блюда.
    Мы осуществляем доставку с использованием специальных термоупаковок, которые сохраняют свежесть и качество продуктов
    на протяжении всего пути до вашего стола. Мы также соблюдаем все необходимые стандарты гигиены и санитарии,
    чтобы обеспечить полное удовлетворение и безопасность при употреблении нашей продукции.</p>`
}
